var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Spinner",style:(_vm.style)},[_c('SpinnerIcon')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }